import { DashboardContainer } from '@modules/dashboard/containers/dashboard_container';
import { Dashboard } from '@modules/dashboard/views/dashboard_view';
import { DateWeatherWidgetView } from '@modules/dashboard/views/date_weather_widget_view';
import { SeedWidgetView } from '@modules/dashboard/views/seed_widget_view';

export function DashboardScreen() {
  return (
    <DashboardContainer
      View={Dashboard}
      DateWeatherWidgetView={DateWeatherWidgetView}
      SeedWidgetView={SeedWidgetView}
    />
  );
}
